<template>
  <div id="app">
    <main>
      <transition name="fade">
        <router-view/>
      </transition>
    </main>
    <BottomBar></BottomBar>
    <div class="debugWin" v-show="debug">
      <p>language : {{ language }}</p>
      <p>darkMode : {{ darkMode }}</p>
      <p>cookie : {{ cookie.length }}</p>
    </div>
  </div>
</template>

<script>
import BottomBar from "@/components/BottomBar"
export default {
  name: 'App',
  components :{
    BottomBar:BottomBar
  },
  data(){
    return{
      debug: false,
      language: "",
      darkMode : false,
      cookie : []
    }
  },
  mounted() {
    // document.documentElement.requestFullscreen();
    // if ( window.matchMedia &&  window.matchMedia( '(prefers-color-scheme: dark)' ).matches ) {
    //   this.darkMode = true;
    // }else{
    //   this.darkMode = false;
    // }
    this.darkMode = false;

    document.cookie = 'shortcuts={"shortcuts": [{"name" : "티스토리", "url": "http://www.naver.com"}] }';

    // this.cookie = JSON.parse( this.getCookie('shortcuts') );
    console.log( JSON.parse(this.getCookie('shortcuts')));
    


    this.language = navigator.language || navigator.userLanguage; 
  },
  methods: {
    addCookie( key, value){

    },
    getCookie( key ) {
      var x, y;
      var val = document.cookie.split(';');

      for (var i = 0; i < val.length; i++) {
        x = val[i].substr(0, val[i].indexOf('='));
        y = val[i].substr(val[i].indexOf('=') + 1);
        x = x.replace(/^\s+|\s+$/g, ''); // 앞과 뒤의 공백 제거하기
        if (x == key) {
          return y; // unescape로 디코딩 후 값 리턴
        }
      }
    }
  },
}
</script>

<style>
*{
  box-sizing: border-box;
}
body{
  padding: 0;
  margin: 0;
  user-select: none;
  background-color: #000000;
  font-family: "Malgun Gothic", "맑은 고딕", helvetica, "Apple SD Gothic Neo", sans-serif;
  overflow: hidden;
}
#app {
  position: relative !important;
  left:0 !important;
  top:0 !important;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  width: 100vw;
  height:100vh;
  overflow: hidden;
  box-sizing: border-box;
}
main{
  position:absolute;
  left:0;
  top:0;
  right:0;
  bottom:120px;
  overflow-x:hidden;
  overflow-y:auto;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
<style scoped>
.debugWin{
  width:500px;
  height:200px;
  background-color:rgba(0,0,0,0.5);
  position:absolute;
  left:10px;
  bottom:10px;
  border:1px solid #333333;
  box-sizing: border-box;
  color:#EEEEEE;
  font-size:12px;
  padding: 20px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/App.vue